import api from './api';

/**
 * Tutorials Service
 * Handles all tutorial management API calls
 */
const tutorialsService = {
    /**
     * Get all tutorials with pagination and filters
     * @param {Object} params - Query parameters
     * @returns {Promise<Object>}
     */
    getAll: async (params = {}) => {
        const queryString = new URLSearchParams(params).toString();
        return api.get(`/admin/tutorials${queryString ? `?${queryString}` : ''}`);
    },

    /**
     * Get tutorial by ID
     * @param {string} id - Tutorial ID
     * @returns {Promise<Object>}
     */
    getById: async (id) => {
        return api.get(`/admin/tutorials/${id}`);
    },

    /**
     * Create new tutorial
     * @param {Object|FormData} data - Tutorial data or FormData for file uploads
     * @returns {Promise<Object>}
     */
    create: async (data) => {
        // Check if data is FormData (for file uploads)
        if (data instanceof FormData) {
            return api.postMultipart('/admin/tutorials', data);
        }
        return api.post('/admin/tutorials', data);
    },

    /**
     * Update tutorial
     * @param {string} id - Tutorial ID
     * @param {Object|FormData} data - Updated tutorial data or FormData for file uploads
     * @returns {Promise<Object>}
     */
    update: async (id, data) => {
        // Check if data is FormData (for file uploads)
        if (data instanceof FormData) {
            return api.putMultipart(`/admin/tutorials/${id}`, data);
        }
        return api.put(`/admin/tutorials/${id}`, data);
    },

    /**
     * Delete tutorial
     * @param {string} id - Tutorial ID
     * @returns {Promise<Object>}
     */
    delete: async (id) => {
        return api.delete(`/admin/tutorials/${id}`);
    }
};

export default tutorialsService;
